import { render, staticRenderFns } from "./SidebarMisc.vue?vue&type=template&id=40eada26&"
import script from "./SidebarMisc.vue?vue&type=script&lang=js&"
export * from "./SidebarMisc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports